import { gql, useMutation } from '@apollo/client'

const ADD_PROGRAM_RACE = gql`
  mutation CreateProgramRace($input: UpsertProgramRaceInput!) {
    upsertProgramRace(input: $input) {
      id
      programEventId
      raceNumber
      typeOfRace
      purse
      distanceId
      runners
      genderRestriction
      ageRestriction
      weight
      wagerIds
      breed
      course
      postTime
      createdDate
      createdBy
      active
    }
  }
`
export interface AddProgramRaceInput {
  programEventId: number
  raceNumber: number
  typeOfRace: string
  purse: string
  distanceId: number
  wagerIds: string
  runners: number
  genderRestriction: string
  ageRestriction: string
  weight: number
  breed: string
  course: string
  postTime: Date
  active: boolean
}

export const useAddProgramRace = () => {
  const [addProgramRace, { loading, error }] = useMutation(ADD_PROGRAM_RACE)
  return { addProgramRace, loading, error }
}
